import React from 'react'

import { logService } from '@/services/log-service'

import { authService } from '../core'

export const signalRAutoStartAndCleanUp = (connection) => {
  const start = async () => {
    if (authService.getTokenClaim('BrandsPay_UserType') === 'Brands' && !authService.isTokenExpired()) {
      try {
        console.log('signalR: ', 'Connecting')
        await connection?.start()
        console.log('signalR: ', 'Connected')
        logService.info('SignalR connected.')
        return
      } catch (error) {
        logService.error('Error connecting to SignalR', {
          error,
          isUserAuthenticated: authService.isUserAuthenticated(),
        })
        if (!authService.isUserAuthenticated()) {
          shouldAutoStart = false
        }
      }
    }
    setTimeout(() => start(), 5000)
  }

  let shouldAutoStart = true
  connection?.onclose(function (error) {
    if (error) {
      logService.error('SignalR disconnected.', { error, shouldAutoStart })
    } else {
      logService.info('SignalR disconnected.', { shouldAutoStart })
    }
    if (shouldAutoStart) {
      start()
    }
  })

  start()

  return function cleanUp() {
    console.log('signalR: ', 'cleanUp')
    shouldAutoStart = false
    try {
      connection?.stop()
    } catch (error) {
      logService.error('Error cleaning up SignalR', { error })
    }
  }
}

export const SignalRContext = React.createContext(null)
